import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import Card from './Card';
import '../App.css';

class VariableRow extends Component {
  render() {
    console.log(this.props.small_card);

    if (this.props.small_card) {
      return (
        <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <Card isSmallCard data={this.props.cards[0]} />
          <Card isSmallCard data={this.props.cards[1]} />
          <Card isSmallCard data={this.props.cards[2]} />
        </div>
      );
    }

    return (
      <Fragment>
        <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <Card isSmallCard={!this.props.is_left_row} data={this.props.cards[0]} />
          <Card isSmallCard={this.props.is_left_row} data={this.props.cards[1]} />
        </div>
      </Fragment>
    );
  }
}

VariableRow.propTypes = {
  small_card: PropTypes.bool.isRequired,
  is_left_row: PropTypes.bool.isRequired,
  cards: PropTypes.array.isRequired,
};


export default VariableRow;
